const moment = require('moment');

export const getQuarterRange = (quarter) => {
  if (quarter <= 0) {
    // If we're trying to get the last quarter and it's the
    // first quarter of this year, we want the last quarter of last year
    const start = moment()
      .subtract(1, 'year')
      .quarter(4)
      .startOf('quarter')
      .format('YYYY-MM-DD');
    const end = moment()
      .subtract(1, 'year')
      .quarter(4)
      .endOf('quarter')
      .format('YYYY-MM-DD');
    return { start, end };
  }

  const start = moment()
    .quarter(quarter)
    .startOf('quarter')
    .format('YYYY-MM-DD');
  const end = moment()
    .quarter(quarter)
    .endOf('quarter')
    .format('YYYY-MM-DD');

  return { start, end };
};

export const getYearRange = () => {
  const start = moment()
    .subtract(1, 'year')
    .format('YYYY-MM-DD');
  const end = moment().format('YYYY-MM-DD');
  return { start, end };
};

export const getLastYearRange = () => {
  const start = moment()
    .subtract(2, 'year')
    .format('YYYY-MM-DD');
  const end = moment()
    .subtract(1, 'year')
    .format('YYYY-MM-DD');
  return { start, end };
};


const formatArray = (array) => {
  const formattedArray = array;
  formattedArray.forEach((item, index) => {
    const formattedText = item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
    formattedArray[index] = formattedText;
  })
  return formattedArray
}

/**
 * Returns capitalized formatted string
 * @param {String} text 
 */
export const capitalize = (text) => {
  let aposArray = [];
  let spaceArray = [];
  if (text.split('-').length > 1) {
    aposArray = formatArray(text.split('-'))
  }
  if (text.split(' ').length > 1) {
    spaceArray = formatArray(text.split(' '))
  }
  if (aposArray.length > 1) return aposArray.join('-');
  if (spaceArray.length > 1) return spaceArray.join(' ');
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}